/* assets/cbi-smooth-scroll.js
 * Starts Lenis (assets/lenis.min.js) for smooth wheel and trackpad scrolling.
 *
 * Lenis animates the window's own scroll position, so everything built on
 * native scrolling keeps working unchanged: position: sticky (header, hero,
 * sub-nav, product columns), the scroll listeners in cbi-header.js and
 * cbi-scheme.js, and the IntersectionObservers in cbi-hero.js and
 * cbi-cabinet.js. Touch scrolling stays native (syncTouch off).
 *
 * Both this and Lenis load async rather than deferred, so they run as soon as
 * they arrive rather than waiting for the whole document to parse: on a slow
 * connection that wait was most of a second after the page had painted, and
 * anyone scrolling in the gap got native wheel steps followed by eased ones.
 * Async means neither Lenis nor the body is promised when this runs, so it
 * starts on the first frame where it has both.
 *
 * Not started in the theme editor, where it would fight the editor's own
 * scrolling to selected sections, nor for visitors who prefer reduced motion.
 * A future drawer or modal that scrolls on its own should carry
 * data-lenis-prevent, or call window.cbiLenis.stop() and start() around it.
 */

(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Both scripts are async, so this one can run before Lenis has arrived and
   * before the body exists. It starts on the first frame where it has both.
   * The deadline is there so a blocked Lenis does not leave a frame callback
   * running for the life of the page. */
  const DEADLINE = 15000;
  const began = Date.now();

  const start = () => {
    if (typeof window.Lenis !== 'function' || !document.body) return false;

    /* Theme setting Glide, 1 to 10, default 5. Each step lengthens the glide
     * by 20 percent: 5 is Lenis's own default lerp of 0.1. */
    const glide = parseInt(document.body.dataset.cbiScrollGlide, 10);
    const steps = Number.isNaN(glide) ? 0 : glide - 5;
    const lerp = Math.min(0.5, Math.max(0.02, 0.1 * Math.pow(0.8, steps)));

    window.cbiLenis = new window.Lenis({
      autoRaf: true,
      lerp,
      anchors: true,
      stopInertiaOnNavigate: true,
    });
    return true;
  };

  const wait = () => {
    if (start()) return;
    if (Date.now() - began > DEADLINE) return;
    window.requestAnimationFrame(wait);
  };

  wait();
})();
